// Auswahlfelder und Schalter (Checkbox) mit data-auto-submit schicken ihr Formular bei
// jeder Änderung ab, etwa der Tenant-Wechsel in der Kopfleiste. Ohne JavaScript bleibt
// der Button im <noscript> dafür.
export default function autoSubmit() {
  document.querySelectorAll('select[data-auto-submit], input[type=checkbox][data-auto-submit]').forEach(function (field) {
    field.addEventListener('change', function () {
      if (field.form) field.form.requestSubmit();
    });
  });
}
